<!--
  Created 27.10.2024
  Simple SortUpDownIcon component
  Depending on the sort order, it displays an up or down arrow
-->
<template>
  <div :class="classes">
    <BarsArrowUpIcon
      v-if="sortOrder === 'desc'"
      class="size-4 text-current"
      aria-hidden="true" />
    <BarsArrowDownIcon
      v-else-if="sortOrder === 'asc'"
      class="size-4 text-current"
      aria-hidden="true" />
  </div>
</template>
<script setup>
/* external */
import {
  BarsArrowUpIcon, BarsArrowDownIcon,
} from '@heroicons/vue/16/solid';

defineProps({
  classes: {
    type: String,
    required: false,
    default: 'inline-block text-gray-500',
  },
  sortOrder: {
    type: String,
    required: true,
    validator: (value) => ['asc', 'desc'].includes(value),
  },
});
</script>
